import MapIcon from "@mui/icons-material/Map";
import { Button, Stack, Typography } from "@mui/material";
import { memo, useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import Row from "../../components/UI/Row";
import { useExtensionConfigs } from "../../hooks/useExtensionConfigs";
import { Extension } from "../../models/intalled-extensions";

const TRANSLATION_PATH = "page.schedules.scheduleDetails.";

interface ICalendarAddressProps {
  address?: string | null;
  compact?: boolean;
  showMapButton?: boolean;
}

const CalendarAddress: React.FC<ICalendarAddressProps> = ({
  address,
  compact,
  showMapButton = false,
}) => {
  const { t } = useTranslation();
  const { fetchExtensionConfig } = useExtensionConfigs();
  const [mapUrl, setMapUrl] = useState("");

  const fetchMapUrl = useCallback(async () => {
    const configAddress = await fetchExtensionConfig(
      Extension.MY_SCHEDULES,
      "Address",
    );

    if (configAddress?.value) {
      setMapUrl(configAddress.value);
    }
  }, [fetchExtensionConfig]);

  useEffect(() => {
    if (showMapButton) fetchMapUrl();
  }, [showMapButton, fetchMapUrl]);

  const trimmedAddress = address?.trim();

  if (!trimmedAddress) return null;

  return (
    <Stack gap={1} alignItems="flex-start">
      <Row
        label={t(TRANSLATION_PATH + "calendar_address")}
        value={trimmedAddress}
        compact={compact}
      />
      {showMapButton && mapUrl && (
        <Button
          component="a"
          href={mapUrl}
          target="_blank"
          rel="noopener noreferrer"
          variant="contained"
          sx={{ gap: 1, textTransform: "none", py: 1 }}
        >
          <MapIcon />

          <Typography>{t(TRANSLATION_PATH + "view_on_map")}</Typography>
        </Button>
      )}
    </Stack>
  );
};

export default memo(CalendarAddress);
